export const PLAN_LOAD_TYPE_FILTERS = [
    { text: '-- Select --', value: '' },
    { text: 'DRUG LIST', value: 'DRUG_LIST' },
    { text: 'PLANS', value: 'PLANS' },
];
export const PLAN_LOAD_STATUS_FILTERS = [
    { text: '-- Select --', value: '' },
    { text: 'SUCCESS', value: 'COMPLETED' },
    { text: 'FAILURE', value: 'FAILED' },
    { text: 'IN PROGRESS', value: 'IN_PROGRESS' },
];

export const getTransferStatusFilters = (intl) => [
    {
        text: intl.formatMessage({ id: 'admin.serff.transferStatus.dropdown.status.placeholder' }),
        value: '',
    },
    { text: 'SUCCESS', value: 'S' },
    { text: 'FAILURE', value: 'F' },
    { text: 'IN PROGRESS', value: 'P' },
];
  

export const TRANSFER_STATUS_MAPPING = {
    S: 'Success',
    F: 'Failure',
    P: 'In Progress',
};

export const SORT = 'SORT';
export const HIDE_COLUMN = 'HIDE_COLUMN';